export default __webpack_public_path__ + "static/ti_bike_pink-1509411c2e3702ec1736f6df05a053ce.svg";